import axiosInstance from "../API/axiosInstance";


export const getAllEvents = async () => {
    const { data } = await axiosInstance.get("/get_event");
    return data;
};

export const getEventById = async (id) => {
    const { data } = await axiosInstance.get(`/get_event/${id}`);
    return data;
};

export const getEventGuests = async (id) => {
    const { data } = await axiosInstance.get(`/get_eventguest/${id}`);
    return data;
};

export const getEventSpeakers = async (id) => {
    const { data } = await axiosInstance.get(`/get_eventspeaker/${id}`);
    return data;
};

export const getEventHosts = async (id) => {
    const { data } = await axiosInstance.get(`/get_eventhost/${id}`);
    return data;
};

export const getEventGlobalCompassMembers = async (id) => {
    const { data } = await axiosInstance.get(`/get_globalcompass/${id}`);
    return data;
};

export const getEventIncludedItems = async (id) => {
    const { data } = await axiosInstance.get(`/get_whatincluded/${id}`);
    return data;
};

export const bookEvent = async (payload) => {
    const { data } = await axiosInstance.post("/bookevent", payload);
    return data;
};

export const likeandUnlikeEvent = async (payload) => {
    const { data } = await axiosInstance.post("/like_unlikeevent", payload);
    return data;
};

export const getMyEvents = async () => {
    const { data } = await axiosInstance.get("/mybookings");
    return data;
};

export const getFoodPreferenceQuestions = async (id) => {
    const { data } = await axiosInstance.get(`/food-preference-questions/${id}`);
    return data;
};

export const submitFoodPreference = async (payload) => {
    const { data } = await axiosInstance.post("/submit-food-preference", payload);
    return data;
};

export const getAllPartners = async () => {
    const { data } = await axiosInstance.get("/get-partners");
    return data;
};

export const getAllEventSessionsTables = async () => {
    const { data } = await axiosInstance.get("/events/sessions/live-with-tables");
    return data;
};
